/**
 * Hôtellerie / restauration — the hospitality vertical.
 *
 * `CORE_MODULES` comes from its own leaf, not from `profiles.ts`: that file
 * folds over the module registry, so importing it here would close a runtime
 * cycle and leave the constant undefined at import time.
 */
import { CORE_MODULES, CORE_ONBOARDING } from "../../sector/core-modules.js";
export const hospitaliteProfile = {
    code: "HOSPITALITE",
    label: "Hôtellerie / restauration",
    description: "Hôtel, auberge, restaurant, maquis, bar",
    icon: "hotel",
    modules: [
        ...CORE_MODULES,
        "pos",
        "stock",
        "tables",
        "menu",
        "stations",
        "rooms",
        "stays",
        "indicators",
    ],
    onboarding: [...CORE_ONBOARDING],
    terminology: {},
    accountingSystem: "NORMAL",
    audcifClass: "services",
    defaultPosMode: true,
    defaultPriceMode: "TTC",
    psvbApplicable: false,
    categories: [],
    defaultTaxGroup: "B",
};
//# sourceMappingURL=profile.js.map